import React, { useState } from "react";
import { toast } from "sonner";
import { Camera, CheckCircle2, FolderOpen, Trash2 } from "lucide-react";
import { formatErr } from "../../lib/api";
import { uploadTestFile } from "../../lib/testLibrary";

const bigBtn = { display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "14px 12px", fontSize: 14, fontWeight: 700, border: "1px solid rgba(255,255,255,0.18)", background: "#111", color: "#fff", cursor: "pointer", flex: 1 };

export const VideoCapture = ({ t, vids, setVids, testid }) => {
  const [pct, setPct] = useState(null);
  const required = t.video_requirement === "required" || t.result_type === "video";
  const pick = async (e) => {
    const file = e.target.files?.[0]; e.target.value = "";
    if (!file) return;
    setPct(0);
    try { const r = await uploadTestFile(file, "result_video", setPct); setVids([...vids, r]); toast.success("Vídeo guardado correctamente"); }
    catch (err) { toast.error(formatErr(err)); } finally { setPct(null); }
  };
  return (
    <div style={{ border: `1px solid ${required && !vids.length ? "#f8717155" : "rgba(255,255,255,0.1)"}`, padding: 14 }} data-testid={testid}>
      <div style={{ fontWeight: 700, marginBottom: 6 }}>Vídeo de la ejecución {required ? <span style={{ color: "#f87171" }}>· obligatorio</span> : <span style={{ color: "#a3a3a3" }}>· opcional</span>}</div>
      {t.video_instructions && <div style={{ fontSize: 13, marginBottom: 4 }} data-testid={`${testid}-what`}><b>Qué grabar:</b> {t.video_instructions}</div>}
      {t.video_angle && <div style={{ fontSize: 13, marginBottom: 8 }} data-testid={`${testid}-angle`}><b>Ángulo:</b> {t.video_angle}</div>}
      {vids.map((v, i) => (
        <div key={v.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#4ade80", marginBottom: 6 }} data-testid={`${testid}-saved-${i}`}>
          <CheckCircle2 size={16} /> {v.name} guardado
          <button onClick={() => setVids(vids.filter((x) => x.id !== v.id))} style={{ background: "none", border: "none", color: "#a3a3a3", cursor: "pointer" }} data-testid={`${testid}-remove-${i}`}><Trash2 size={14} /></button>
        </div>
      ))}
      {pct !== null ? (
        <div data-testid={`${testid}-progress`}>
          <div style={{ fontSize: 12, marginBottom: 4 }}>Subiendo vídeo… {pct}%</div>
          <div style={{ height: 8, background: "#222" }}><div style={{ height: 8, width: `${pct}%`, background: "var(--qv-red, #E11D2E)", transition: "width 0.3s" }} /></div>
        </div>
      ) : (
        <div style={{ display: "flex", gap: 8 }}>
          <label style={bigBtn} data-testid={`${testid}-record`}><Camera size={18} /> Grabar<input type="file" accept="video/*" capture="environment" onChange={pick} style={{ display: "none" }} data-testid={`${testid}-record-input`} /></label>
          <label style={bigBtn} data-testid={`${testid}-pick`}><FolderOpen size={18} /> Galería<input type="file" accept="video/*" onChange={pick} style={{ display: "none" }} data-testid={`${testid}-pick-input`} /></label>
        </div>
      )}
    </div>
  );
};
